"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useLanguage;

var _useLocalizedStrings = _interopRequireDefault(require("./internal/useLocalizedStrings"));

var _useWebChatAPIContext2 = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useLanguage(options) {
  var _useWebChatAPIContext = (0, _useWebChatAPIContext2.default)(),
      language = _useWebChatAPIContext.language;

  var localizedStrings = (0, _useLocalizedStrings.default)();

  if (options === 'speech') {
    return [localizedStrings.SPEECH_LANGUAGE || language];
  }

  return [language];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VMYW5ndWFnZSIsIm9wdGlvbnMiLCJ1c2VXZWJDaGF0QVBJQ29udGV4dCIsImxhbmd1YWdlIiwibG9jYWxpemVkU3RyaW5ncyIsInVzZUxvY2FsaXplZFN0cmluZ3MiLCJTUEVFQ0hfTEFOR1VBR0UiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VMYW5ndWFnZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlTG9jYWxpemVkU3RyaW5ncyBmcm9tICcuL2ludGVybmFsL3VzZUxvY2FsaXplZFN0cmluZ3MnO1xuaW1wb3J0IHVzZVdlYkNoYXRBUElDb250ZXh0IGZyb20gJy4vaW50ZXJuYWwvdXNlV2ViQ2hhdEFQSUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VMYW5ndWFnZShvcHRpb25zPzogJ3NwZWVjaCcpOiBbc3RyaW5nXSB7XG4gIGNvbnN0IHsgbGFuZ3VhZ2UgfSA9IHVzZVdlYkNoYXRBUElDb250ZXh0KCk7XG4gIGNvbnN0IGxvY2FsaXplZFN0cmluZ3MgPSB1c2VMb2NhbGl6ZWRTdHJpbmdzKCk7XG5cbiAgaWYgKG9wdGlvbnMgPT09ICdzcGVlY2gnKSB7XG4gICAgcmV0dXJuIFtsb2NhbGl6ZWRTdHJpbmdzLlNQRUVDSF9MQU5HVUFHRSB8fCBsYW5ndWFnZV07XG4gIH1cblxuICByZXR1cm4gW2xhbmd1YWdlXTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUNBOzs7O0FBRWUsU0FBU0EsV0FBVCxDQUFxQkMsT0FBckIsRUFBbUQ7RUFDaEUsNEJBQXFCLElBQUFDLDhCQUFBLEdBQXJCO0VBQUEsSUFBUUMsUUFBUix5QkFBUUEsUUFBUjs7RUFDQSxJQUFNQyxnQkFBZ0IsR0FBRyxJQUFBQyw0QkFBQSxHQUF6Qjs7RUFFQSxJQUFJSixPQUFPLEtBQUssUUFBaEIsRUFBMEI7SUFDeEIsT0FBTyxDQUFDRyxnQkFBZ0IsQ0FBQ0UsZUFBakIsSUFBb0NILFFBQXJDLENBQVA7RUFDRDs7RUFFRCxPQUFPLENBQUNBLFFBQUQsQ0FBUDtBQUNEIn0=